export default __webpack_public_path__ + "static/media/2081.97fbfcd7.png";